<template>
  <div class="container">
    <!-- 日期选择器 -->
    <el-row>
      <el-col>
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-config-provider :locale="zhCn">
              筛选时间段：
              <el-date-picker
                  v-model="listQuery.DTStartCreatedDate"
                  type="date"
                  placeholder="开始时间"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  @change="validateDate"
              />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            <el-config-provider :locale="zhCn">
              <el-date-picker
                  v-model="listQuery.DTEndCreatedDate"
                  type="date"
                  placeholder="结束时间"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  @change="validateDate"
              />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            排序方式：
            <el-select
                v-model="tableMode"
                size="small"
                class="mode-select"
                placeholder="请选择"
            >
              <el-option label="按部门" value="department" />
              <el-option label="按班级" value="group" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="fetchData">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="resetFilter">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="openDeptDialog">
              {{ selectedDeptIds.length > 0 ? `部门筛选（已选 ${selectedDeptIds.length} 个）` : '部门筛选' }}
            </el-button>
          </el-form-item>
        </el-form>

      </el-col>
    </el-row>

    <!-- 已选部门 -->
    <el-row v-if="selectedDeptIds.length">
      <div class="selected-depts">
        <span class="selected-depts-label">已选部门：</span>
        <el-tag
            v-for="dept in selectedDeptList"
            :key="dept.StrID"
            closable
            size="small"
            class="dept-tag"
            @close="removeDept(dept.StrID)"
        >{{ dept.StrName }}</el-tag>
        <el-button type="text" size="small" @click="clearDepts">清除</el-button>
      </div>
    </el-row>

    <!-- 部门多选弹窗 -->
    <el-dialog
        title="选择部门"
        v-model="deptDialogVisible"
        width="30%"
        :close-on-click-modal="false"
        append-to-body
    >
      <div v-loading="deptLoading">
        <div class="dept-dialog-toolbar">
          <el-checkbox :model-value="deptAllChecked" :indeterminate="deptIndeterminate" @change="toggleAllDept">全选</el-checkbox>
          <span class="dept-dialog-count">已选 {{ tempDeptIds.length }} / {{ departmentList.length }}</span>
        </div>
        <el-divider></el-divider>
        <el-checkbox-group v-model="tempDeptIds" class="dept-checkbox-group">
          <el-checkbox
              v-for="dept in departmentList"
              :key="dept.StrID"
              :label="dept.StrID"
              class="dept-checkbox"
          >{{ dept.StrName }}</el-checkbox>
        </el-checkbox-group>
        <div v-if="!deptLoading && departmentList.length === 0" class="dept-empty">
          本馆暂无部门数据
        </div>
      </div>
      <div class="dialog-footer" style="text-align: right; margin-top: 10px;">
        <el-button size="small" @click="deptDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="confirmDept">确定</el-button>
      </div>
    </el-dialog>

    <!-- 表格 -->
    <div class="section">
      <div class="section-title">馆藏信息</div>
      <div class="info-table">
        <div class="row">
          <div class="cell">种数（种）</div>
          <div class="cell">{{totalISBN}}</div>
          <div class="cell">册数（册）</div>
          <div class="cell">{{totalCount}}</div>
          <div class="cell">平均复本（册）</div>
          <div class="cell">{{totalISBN > 0 ? (totalCount/totalISBN).toFixed(2) : '0'}}</div>
        </div>
      </div>
    </div>

    <!-- 学年统计展示 -->
    <div class="section">
      <div class="section-title">生均统计</div>
      <div class="info-table">
        <div class="row">
          <div class="cell">读者数</div>
          <div class="cell">{{Readertotal}}</div>
          <div class="cell">生均馆藏量(册/人)</div>
          <div class="cell">
            {{
              Readertotal > 0 ? (totalCount / Readertotal).toFixed(2) : '0'
            }}
          </div>
          <div class="cell">生均流通量(册/人)</div>
          <div class="cell">{{ averageCirculationPerReader }}</div>
        </div>
      </div>
    </div>

    <!-- 流通统计 -->
    <div class="section">
      <div class="section-title">
        流通统计
      </div>

      <el-table
          v-if="Circlist"
          :data="Circlist"
          style="width: 100%"
          border
          size="small"
          :summary-method="getSummaries"
          show-summary
      >
<!--        <el-table-column-->
<!--            :prop="tableMode === 'department' ? 'StrDepartmentName' : 'StrGroupName'"-->
<!--            :label="tableMode === 'department' ? '部门' : '班级'"-->
<!--            align="center"-->
<!--        />-->

        <el-table-column
            :label="tableMode === 'department' ? '部门' : '班级'"
            align="center"
        >
          <template v-slot="{ row }">
            {{ tableMode === 'department' ? row.StrDepartmentName : `(${row.StrDepartmentName})  ${row.StrGroupName}` }}
          </template>
        </el-table-column>
        <el-table-column prop="ReaderCount" label="读者数" align="center" />
        <el-table-column prop="BorrowReaderCount" label="借阅读者数" align="center" />

        <el-table-column label="借阅读者占比" align="center">
          <template v-slot="{ row }">
            {{ row.ReaderCount > 0 ? ((row.BorrowReaderCount / row.ReaderCount) * 100).toFixed(2) : '0' }}%
          </template>
        </el-table-column>

        <el-table-column prop="BorrowCount" label="借阅数" align="center" />
        <el-table-column prop="ReturnCount" label="归还数" align="center" />
        <el-table-column prop="RenewCount" label="续借数" align="center" />

        <el-table-column label="平均借阅量" align="center">
          <template v-slot="{ row }">
            {{ row.ReaderCount > 0 ? (row.BorrowCount / row.ReaderCount).toFixed(2) : '0' }}
          </template>
        </el-table-column>

      </el-table>
    </div>


  </div>
</template>

<script>
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { ElMessage } from 'element-plus'
import {BASE_URL} from "@/utils/constants";
import {toUTCDateTime} from "@/utils/date";
export default {
  name: 'CirculationStatistics',
  data() {
    return {
      tableMode: 'group', // 可选值：'department' | 'group'
      //CirculationInfo
      Circlist:null,
      //readerInfo
      Readertotal:0,
      //libInfo
      totalISBN:0,
      totalCount:0,
      list: null,
      listQuery: {
        DTStartCreatedDate: '',
        DTEndCreatedDate: ''
      },
      // 部门筛选
      deptDialogVisible: false,
      deptLoading: false,
      departmentList: [],   // 本馆全部部门
      selectedDeptIds: [],  // 已应用的部门 ID
      tempDeptIds: []       // 弹窗内临时勾选
    }
  },
  computed: {
    zhCn() {
      return zhCn
    },
    // 已选部门的完整信息（用于标签展示）
    selectedDeptList() {
      return this.departmentList.filter(dept => this.selectedDeptIds.includes(dept.StrID));
    },
    deptAllChecked() {
      return this.departmentList.length > 0 && this.tempDeptIds.length === this.departmentList.length;
    },
    deptIndeterminate() {
      return this.tempDeptIds.length > 0 && this.tempDeptIds.length < this.departmentList.length;
    },
    averageCirculationPerReader() {
      if (!this.Circlist || this.Readertotal === 0) return 0;

      let totalCirculation = this.Circlist.reduce((sum, item) => {
        return sum + (item.BorrowCount || 0) + (item.ReturnCount || 0) + (item.RenewCount || 0);
      }, 0);

      return (totalCirculation / this.Readertotal).toFixed(2);
    }
  },
  mounted() {
    this.getDepartmentList()
    this.getLibInfo()
    this.getReaderInfo()
    this.getCirculationInfo()
  },
  watch: {
    tableMode() {
      this.getCirculationInfo();
    }
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }

        // 处理其他列（ReaderCount, BorrowCount, ReturnCount, RenewCount）
        if (column.property && column.property !== 'averageBorrow') {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              return isNaN(value) ? prev : prev + value;
            }, 0);
          } else {
            sums[index] = '';
          }
        } else if (column.label === '平均借阅量') {
          // 计算平均借阅量：总借阅数 / 总学生数
          const totalRenew = data.reduce((sum, item) => sum + (Number(item.RenewCount) || 0), 0);
          const totalReturn = data.reduce((sum, item) => sum + (Number(item.ReturnCount) || 0), 0);
          const totalBorrow = data.reduce((sum, item) => sum + (Number(item.BorrowCount) || 0), 0);
          const totalReaders = data.reduce((sum, item) => sum + (Number(item.ReaderCount) || 0), 0);
          sums[index] = totalReaders > 0 ? (totalBorrow / totalReaders).toFixed(2) : '0';
        }else if(column.label === '借阅读者占比'){
          // 计算借阅读者占比：总借阅读者数 / 总读者数 * 100
          const totalBorrowReaders = data.reduce((sum, item) => sum + (Number(item.BorrowReaderCount) || 0), 0);
          const totalReaders = data.reduce((sum, item) => sum + (Number(item.ReaderCount) || 0), 0);
          sums[index] = totalReaders > 0 ? ((totalBorrowReaders / totalReaders) * 100).toFixed(2) + '%' : '0%';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    disabledDate(time) {
      return time.getTime() > Date.now()
    },
    validateDate() {
      const start = new Date(this.listQuery.DTStartCreatedDate)
      const end = new Date(this.listQuery.DTEndCreatedDate)
      if (start && end && end < start) {
        ElMessage.error('结束时间不能小于开始时间')
        this.listQuery.DTEndCreatedDate = ''
      }
    },
    resetFilter() {
      this.listQuery.DTStartCreatedDate = ''
      this.listQuery.DTEndCreatedDate = ''
      this.selectedDeptIds = []
      this.getReaderInfo()
      this.getLibInfo()
      this.getCirculationInfo()
    },
    getLibInfo(){
      const search = {};
      search.IsCLC = true;
      // 处理日期范围，只在非空且非 undefined 时添加
      // if (this.listQuery.DTStartCreatedDate !== undefined && this.listQuery.DTStartCreatedDate !== '' && this.listQuery.DTStartCreatedDate !== null) {
      //   search.DTStartTime = this.listQuery.DTStartCreatedDate + 'T00:00:00.999Z';
      // }
      //
      // if (this.listQuery.DTEndCreatedDate !== undefined && this.listQuery.DTEndCreatedDate !== '' && this.listQuery.DTEndCreatedDate !== null) {
      //   search.DTEndTime = this.listQuery.DTEndCreatedDate + 'T23:59:59.999Z';
      // }
      this.$axios({
        url: BASE_URL + 'organizations/booktypescount',
        method: 'post',
        data: JSON.stringify(search),
        // 发送格式为 json
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.totalISBN = 0;
          this.totalCount = 0;
          this.list = [];

          this.list = res.data.msg;
          const totalData = this.list[this.list.length - 1];
          const totalISBN = totalData.TotalISBN; // 13273
          const totalCount = totalData.TotalCount; // 46252
          const totalCost = totalData.CostCount; // 1161601.47

          this.totalISBN = totalISBN;
          this.totalCount = totalCount;

          console.log('Total ISBN:', totalISBN);
          console.log('Total Count:', totalCount);
          console.log('Total Cost:', totalCost);
        } else {
          ElMessage.error(res.data.msg)
        }
      });
    },
    // 获取本馆所有部门(GET,无尾斜杠:fiber Group+Get("/") 注册路径为 /departments,带斜杠会 404)
    getDepartmentList() {
      this.$axios({
        url: BASE_URL + 'departments',
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.departmentList = res.data.msg || [];
        } else {
          ElMessage.error(res.data.msg)
        }
      });
    },
    // 打开部门多选弹窗:同步临时勾选并刷新部门列表
    openDeptDialog() {
      this.tempDeptIds = [...this.selectedDeptIds];
      this.deptDialogVisible = true;
      this.deptLoading = true;
      this.$axios({
        url: BASE_URL + 'departments',
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.departmentList = res.data.msg || [];
          // 过滤掉已被删除的部门 ID
          const validIds = this.departmentList.map(dept => dept.StrID);
          this.tempDeptIds = this.tempDeptIds.filter(id => validIds.includes(id));
        } else {
          ElMessage.error(res.data.msg)
        }
      }).finally(() => {
        this.deptLoading = false;
      });
    },
    // 弹窗全选/取消全选
    toggleAllDept(val) {
      this.tempDeptIds = val ? this.departmentList.map(dept => dept.StrID) : [];
    },
    // 弹窗确定:应用选择并按部门重新统计读者数和流通数据
    confirmDept() {
      this.selectedDeptIds = [...this.tempDeptIds];
      this.deptDialogVisible = false;
      this.getReaderInfo();
      this.getCirculationInfo();
    },
    // 移除单个已选部门
    removeDept(deptId) {
      this.selectedDeptIds = this.selectedDeptIds.filter(id => id !== deptId);
      this.getReaderInfo();
      this.getCirculationInfo();
    },
    // 清除全部部门筛选
    clearDepts() {
      this.selectedDeptIds = [];
      this.getReaderInfo();
      this.getCirculationInfo();
    },
    // 统计读者数量:未选部门时统计本馆全部读者,选了部门只统计所选部门
    getReaderInfo(){
      const param = {};
      if (this.selectedDeptIds.length > 0) {
        param.StrDepartmentID = [...this.selectedDeptIds];
      }
      this.$axios({
        url: BASE_URL + 'readers/countReaders',
        method: 'post',
        data: JSON.stringify(param),
        // 发送格式为 json
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.Readertotal = res.data.msg;
        }else {
          ElMessage.error(res.data.msg)
        }
      });

    },

    getCirculationInfo() {
      const param = {
        Search: {}
      };
      if (this.listQuery.DTStartCreatedDate) {
        param.Search["DTStartCreatedDate"] = toUTCDateTime(this.listQuery.DTStartCreatedDate, 'start');
      }
      if (this.listQuery.DTEndCreatedDate) {
        param.Search["DTEndCreatedDate"] = toUTCDateTime(this.listQuery.DTEndCreatedDate, 'end');
      }
      // 按部门范围过滤(数组 IN;不传或空数组时后台统计全部部门)
      if (this.selectedDeptIds.length > 0) {
        param.Search["StrDepartmentID"] = [...this.selectedDeptIds];
      }
      this.$axios({
        url: BASE_URL + 'organizations/datasbygroup',
        method: 'post',
        data: JSON.stringify(param),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          if (this.tableMode === 'department') {
            // 合并相同 StrDepartmentID 的项
            const departmentMap = {};
            for (const item of res.data.msg) {
              const deptId = item.StrDepartmentID || '未知';
              if (!departmentMap[deptId]) {
                departmentMap[deptId] = {
                  StrDepartmentID: deptId,
                  StrDepartmentName: item.StrDepartmentName || '未知部门',
                  BorrowCount: 0,
                  ReturnCount: 0,
                  RenewCount: 0,
                  ReaderCount: 0,
                  BorrowReaderCount: 0
                };
              }
              departmentMap[deptId].BorrowCount += item.BorrowCount || 0;
              departmentMap[deptId].ReturnCount += item.ReturnCount || 0;
              departmentMap[deptId].RenewCount += item.RenewCount || 0;
              departmentMap[deptId].ReaderCount += item.ReaderCount || 0;
              departmentMap[deptId].BorrowReaderCount += item.BorrowReaderCount || 0;
            }
            this.Circlist = Object.values(departmentMap);
          } else {

            // 按班级展示数据，确保 StrDepartmentName 和 StrGroupName 有默认值，并按部门和班级排序
            this.Circlist = res.data.msg
                .map(item => ({
                  ...item,
                  StrDepartmentName: item.StrDepartmentName || '未知部门',
                  StrGroupName: item.StrGroupName || '未知班级'
                }))
                .sort((a, b) => {
                  // 首先按 StrDepartmentName 排序
                  const deptCompare = (a.StrDepartmentName || '').localeCompare(b.StrDepartmentName || '');
                  if (deptCompare !== 0) return deptCompare;
                  // 如果部门相同，按 StrGroupName 排序
                  return (a.StrGroupName || '').localeCompare(b.StrGroupName || '');
                });
          }
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    },
    fetchData(){
      this.getLibInfo()
      this.getReaderInfo()
      this.getCirculationInfo()
    },

  },
  created() {}
}
</script>

<style scoped>
.container {
  padding: 20px;
}
.section {
  margin-top: 0px;
}
.section-title {
  background-color: #cde6f7;
  color: #000;
  padding: 5px;
  border: 1px solid #ccc;
  font-weight: bold;
  font-size: 14px;
}
.info-table {
  border: 1px  #ccc;
  border-top: none;
}
.row {
  display: flex;
  background-color: #ecf5ff;
  border-bottom: 1px solid #ccc;
}
.cell {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #ccc;
  text-align: center;
  font-size: 14px;
}
.cell:last-child {
  border-right: none;
}

.mode-select {
  margin-left: 10px;
  width: 95px;
}

::v-deep(.el-table) {
  font-size: 14px;
}
::v-deep(.el-table__body td) {
  padding: 8px 8px;
}

.selected-depts {
  padding: 0 20px 10px 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.selected-depts-label {
  font-size: 14px;
  color: #606266;
}
.dept-tag {
  margin-right: 0;
}

.dept-dialog-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dept-dialog-count {
  font-size: 13px;
  color: #909399;
}
.dept-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  max-height: 300px;
  overflow-y: auto;
}
.dept-checkbox {
  width: 45%;
  margin-right: 0;
  margin-bottom: 8px;
}
.dept-empty {
  text-align: center;
  color: #909399;
  font-size: 14px;
  padding: 20px 0;
}

</style>
